import React, { useEffect, useState, useCallback } from 'react'

import { AddPenaltyAmountPane } from './AddPenaltyAmountPane'
import { useDispatch } from 'react-redux'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'
import {PenaltyDataGrid} from "./PenaltyDataGrid";

export const PenaltyAmountPage = ({ defaultFilters }) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)

  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data, ...defaultFilters }
      setGetAPIResult(null)
      new rest.PenaltyService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could Not Load  Data.', JSON.stringify(errors))
          )
        })
    },
    [dispatch, gridData, defaultFilters]
  )
  useEffect(() => {
    getData()
  }, [getData, dispatch])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <PenaltyDataGrid
          handleTableChange={handleTableChange}
          onFilter={onFilter}
          getData={getData}
          results={getAPIResults.results}
          page_size={getAPIResults.page_size}
          count={getAPIResults.count}
          current={getAPIResults.current}
          onDelete={(item) => {
              getData({})
          }}

          hiddenRowKeys={[]}
          onError={undefined}      >
        <AddPenaltyAmountPane
          onSubmit={getData}
          title="Add Loaner Penalty"
        />
      </PenaltyDataGrid>
    </>
  )
}
